/* import __COLOCATED_TEMPLATE__ from './ai-star-and-name-dropdown-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();